/**
 * Global Search Overlay
 */
export const SearchOverlay = {
  init() {
    this.el = document.getElementById('nw-search-overlay');
    if (!this.el) return;

    this.input = this.el.querySelector('[data-nw-search-input]');

    document.querySelectorAll('[data-nw-search-open]').forEach((btn) => {
      btn.addEventListener('click', () => this.open());
    });

    document.addEventListener('keydown', (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === '/') {
        e.preventDefault();
        this.open();
      }
    });

    this.el.addEventListener('click', (e) => {
      if (e.target === this.el) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.el.classList.contains('show')) this.close();
    });
  },

  open() {
    this.el.classList.add('show');
    this.input?.focus();
  },

  close() {
    this.el.classList.remove('show');
    if (this.input) this.input.value = '';
  },
};
